// src/pages/chat/settings/profile/upload-image/upload-image.styled.ts
import styled from "@emotion/styled";
import * as Dialog from "@radix-ui/react-dialog";
import { COLORS } from "../../../header/header.styled";

export const Backdrop = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: rgba(0, 0, 0, 0.55);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    z-index: 1004;
`;

export const Content = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    margin: auto;
    width: calc(100vw - 32px);
    max-width: 520px;
    height: fit-content;
    max-height: calc(100vh - 32px);
    overflow: hidden;

    background: ${COLORS.surface};
    border: 1px solid ${COLORS.border};
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35), 0 1px 0 ${COLORS
        .neutralOverlay} inset;

    z-index: 1005;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 14px 14px;
    border-bottom: 1px solid ${COLORS.border};
`;

export const Title = styled(Dialog.Title)`
    margin: 0;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-size: 15px;
    font-weight: 700;
    color: ${COLORS.textPrimary};
`;

export const CloseBtn = styled.button`
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid ${COLORS.border};
    background: ${COLORS.general};
    color: ${COLORS.textPrimary};
    cursor: pointer;
    font-weight: 700;

    &:hover {
        border-color: ${COLORS.focusRing};
    }

    &:focus {
        outline: none;
        border-color: ${COLORS.focusRing};
        box-shadow: inset 0 0 0 1px ${COLORS.focusRing};
    }
`;

export const Body = styled.div`
    padding: 14px 14px 10px 14px;
`;

export const PreviewWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const PreviewCircle = styled.div`
    width: 240px;
    height: 240px;
    border-radius: 50%;
    background: ${COLORS.general};
    border: 2px solid ${COLORS.border};
    overflow: hidden;
    position: relative;
    touch-action: none;
    -webkit-user-select: none;
    user-select: none;

    &:focus-within {
        outline: none;
        border-color: ${COLORS.focusRing};
        box-shadow: inset 0 0 0 2px ${COLORS.focusRing};
    }
`;

export const PreviewImg = styled.img`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;

    /* Prevent native drag ghost */
    -webkit-user-drag: none;
    -webkit-user-select: none;
    user-select: none;

    /* Smoothness */
    transform-origin: center center;
`;

export const PreviewHint = styled.div`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-size: 12px;
    color: ${COLORS.textMuted};
`;

export const ControlsRow = styled.div`
    margin-top: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const SliderLabel = styled.label`
    min-width: 44px;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-size: 13px;
    color: ${COLORS.textMuted};
`;

export const Slider = styled.input`
    width: 100%;
    accent-color: ${COLORS.accent};
    cursor: pointer;
`;

export const ErrorText = styled.div`
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: 12px;
    background: rgba(255, 0, 0, 0.08);
    border: 1px solid rgba(255, 0, 0, 0.2);
    color: ${COLORS.textPrimary};
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";
    font-size: 13px;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;

    padding: 12px 14px 14px 14px;
    border-top: 1px solid ${COLORS.border};
`;

export const Btn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid ${COLORS.border};
    background: ${COLORS.general};
    color: ${COLORS.textPrimary};
    font-weight: 700;
    cursor: pointer;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        "Helvetica Neue",
        Arial,
        "Noto Sans";

    &:hover {
        border-color: ${COLORS.focusRing};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &:focus {
        outline: none;
        border-color: ${COLORS.focusRing};
        box-shadow: inset 0 0 0 1px ${COLORS.focusRing};
    }
`;

export const BtnPrimary = styled(Btn)`
    border: none;
    background: ${COLORS.accent};
    color: ${COLORS.onPrimary};

    &:hover {
        background: ${COLORS.btnHover};
        border: none;
    }
`;
